/**
 * RAG API 服務 - 調用 Firebase Cloud Function
 */

const CHAT_API_URL = 'https://us-central1-surepal-web-app-13a7a.cloudfunctions.net/chatWithPolicy';

export interface RAGChatRequest {
  userId: string;
  message: string;
  policyId?: string;
  conversationId?: string;
}

export interface RAGChatResponse {
  reply: string;
  sources: Array<{
    content: string;
    policyNumber: string;
    similarity: number;
  }>;
  hasRelevantData: boolean;
}

export class RAGApiService {
  /**
   * 調用 RAG API 進行問答
   */
  async chat(request: RAGChatRequest): Promise<RAGChatResponse> {
    try {
      console.log('📡 調用 RAG API:', {
        userId: request.userId,
        message: request.message.substring(0, 50) + '...',
        policyId: request.policyId || 'all'
      });

      const response = await fetch(CHAT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: request.userId,
          message: request.message,
          policyId: request.policyId,
          conversationId: request.conversationId
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ RAG API 錯誤:', response.status, errorText);
        throw new Error(`API 請求失敗: ${response.status} ${errorText}`);
      }

      const data: RAGChatResponse = await response.json();
      console.log('✅ RAG API 回應:', {
        hasRelevantData: data.hasRelevantData,
        sourcesCount: data.sources?.length || 0,
        replyLength: data.reply.length
      });

      return data;
    } catch (error: any) {
      console.error('❌ RAG API 調用失敗:', error);
      throw error;
    }
  }
}

export const ragApiService = new RAGApiService();

